import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Container, Typography } from '@mui/material';
import JokguTeams from '../components/JokguTeams';

export default function Jokgu() {
  const user = useSelector((state) => state.users.user);
  
  const isLoggedIn =
    useSelector((state) => state.users.isLoggedIn) &&
    localStorage.getItem('token') !== null;

  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !isLoggedIn) {
      navigate('/');
    }
  });

  return (
    <Container
      className="page-container"
      sx={{ maxWidth: '1200px', px: 'max(2%, 16px) !important' }}
    >
      <div className="table-title">
        <h1 style={{ textAlign: 'center' }}>Jokgu Teams</h1>
      </div>
      <JokguTeams />
    </Container>
  );
}
